import { LabelLocationColorType, LabelLocationSizeType } from '../types';

export const LABEL_LOCATION_COLORS_MAP: Record<LabelLocationColorType, string> = {
  orange: 'label-location--orange',
  blue: 'label-location--blue',
  turquoise: 'label-location--turquoise',
  yellow: 'label-location--yellow',
};

export const LABEL_LOCATION_SIZES_MAP: Record<LabelLocationSizeType, string> = {
  small: 'label-location--small',
  large: 'label-location--large',
};
